import React from 'react';
import { Settings2 } from 'lucide-react';
import { FormSchema } from '../types';
import { SectionSummary, SmallField, inputSmall } from './panelParts';

type SetupSectionProps = {
  name: string;
  setName: (value: string) => void;
  description: string;
  setDescription: (value: string) => void;
  schema: FormSchema;
  setSchema: React.Dispatch<React.SetStateAction<FormSchema>>;
};

export default function SetupSection({ name, setName, description, setDescription, schema, setSchema }: SetupSectionProps) {
  return (
          <details data-tour="editor-details" className="group rounded-xl border border-sky-200 border-l-4 border-l-sky-500 bg-sky-50/60 shadow-sm">
            <SectionSummary
              icon={<Settings2 className="h-3.5 w-3.5 text-sky-600" />}
              title="Form details"
              description="Name, title and submit button"
            />
            <div className="space-y-2.5 px-3 pb-3">
              <SmallField label="Form name">
                <input
                  className={inputSmall()}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </SmallField>
              <SmallField label="Description">
                <textarea
                  className={inputSmall()}
                  rows={3}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </SmallField>
              <SmallField label="Submit button">
                <input
                  className={inputSmall()}
                  value={schema.submit_label}
                  onChange={(e) =>
                    setSchema((s) => ({ ...s, submit_label: e.target.value }))
                  }
                />
              </SmallField>
            </div>
          </details>
  );
}
